import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Skeleton } from '@uhg-abyss/web/ui/Skeleton';

const Value = styled('div', {
  color: '$gray8',
  fontSize: '16px',
  lineHeight: '22px',
  fontWeight: 700,
  fontStyle: 'normal',
  marginTop: '2.3%',
  wordWrap: 'break-word',
});

const Section = styled('div', {
  marginBottom: 10,
  '&:last-child': {
    marginBottom: 0,
  },
});

export const LicenseInformation = ({ index, medLicense, value, isLoading }) => {
  return (
    <Section>
      <Value>
        {isLoading ? (
          <Skeleton variant="rounded" height={20} width={200} />
        ) : (
          <div style={{ marginBottom: '-22px' }}>
            <p
              id={`practiceData-medLicense-${index}`}
              style={{ paddingBottom: '5px' }}
            >
              {value === 'value' ? medLicense.state : medLicense[value]}
            </p>
          </div>
        )}
      </Value>
    </Section>
  );
};

LicenseInformation.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  medLicense: PropTypes.shape({
    licenseType: PropTypes.string,
    licenseNumber: PropTypes.string,
    state: PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  }),
  isLoading: PropTypes.bool,
};

LicenseInformation.defaultProps = {
  medLicense: {},
  isLoading: false,
};
